/*
 * @Author: seven.zhang 
 * @Date: 2019-02-18 14:35:53 
 * @Last Modified by: seven.zhang
 * @Last Modified time: 2019-04-11 18:08:51
 */
export default class Util {

    //去除所有空格
    static rmSpace(str) {
        return str.replace(/\s+/g, "");
    }

    /*
      数字转成每三位，用逗号分隔
      this.$UtilTool.formatNum(num)
    */
    static formatNum(num = '') {

        if (typeof num === 'number') {
            num = String(num)
        }
        if (num && num.length < 4) {
            return num;
        }
        if (!/^(\+|-)?(\d+)(\.\d+)?$/.test(num)) {
            return num;
        }
        // 带小数点
        // if(num.indexOf('.')!=-1){
        //     return Number(num).toLocaleString() 
        // }

        var a = RegExp.$1,
            b = RegExp.$2,
            c = RegExp.$3;
        var re = new RegExp().compile("(\\d)(\\d{3})(,|$)");
        while (re.test(b)) b = b.replace(re, "$1,$2$3");
        return a + "" + b + "" + c;
    }

    /**
     * 手动触发页面resize 
     */
    static dispatchDefine (){
        setTimeout( () => {
            if(!!window.ActiveXObject || "ActiveXObject" in window){
                let resizeEvent = window.document.createEvent('UIEvents'); 
                resizeEvent.initUIEvent('resize', true, false, window, 0); 
                window.dispatchEvent(resizeEvent);
            }else {
                window.dispatchEvent(new Event("resize"));
            }
        },0);
    }

    /***
     * 输入节流
     * @param func 输入完成的回调函数
     * @param delay 延迟时间
     */
    static  debounce(func, delay) {
        let timer
        return (...args) => {
            if (timer) {
                clearTimeout(timer)
            }
            timer = setTimeout(() => {
                func.apply(this, args)
            }, delay)
        }
    }

    /***
     * dpr设置
     */
    static setDpr() {
        const screenWidth = document.body.clientWidth;
        // console.log(document.body.clientWidth,window.innerWidth)
        let _dpr = null
        if(screenWidth<1920){
            _dpr = 1
        }else{
            // _dpr = Math.ceil(screenWidth/1920)
            _dpr = Math.floor(screenWidth/1920)
        }
        return _dpr;
    }

    //计算最大值(用于图表计算y轴interval，让左右Y轴分割线重合)
    static calMax(arr) {
        let max = 0;
        arr.forEach((el) => {
            el.forEach((el1) => {
                if (!(el1 === undefined || el1 === '')) {
                    if (max < Number(el1)) {
                        max = Number(el1);
                    }
                }
            })
        })
        let maxint = Math.ceil(max / 9.5);//不让最高的值超过最上面的刻度
        let maxval = maxint * 10;//让显示的刻度是整数
        return maxval;
    }
    //计算最小值(用于图表计算y轴interval，让左右Y轴分割线重合)
    static calMin(arr) {
        let min = 0;
        arr.forEach((el) => {
            el.forEach((el1) => {
                if (!(el1 === undefined || el1 === '')) {
                    if (min > Number(el1)) {
                        min = Number(el1);
                    }
                }
            })
        })
        // let maxint = Math.floor(min)
        // if(maxint%2!=0){
        //     if(maxint<0){
        //         maxint-=1
        //     }else{
        //         maxint+=1
        //     }
        // }//保证值为偶数
        // let minval = min<0?maxint:0;
        let minint = Math.floor(min / 20);
        let minval = minint * 20;//让显示的刻度是整数

        return minval;
    }

    //计算数组中最大值
    static calMax2(arr) {
        let max = arr[0];
        let len = arr.length;
        for (var i = 1; i < len; i++){
            if (parseInt(arr[i]) > max) {
                max = parseInt(arr[i]);
            }
        }
        return max;
    }

    //判断是否有小数
    static hasPoint(num) {
        parseInt(num)==num
        return !(parseInt(num)==num);
    }

    /**
     * 保留几位小数
     * @param {数值} num 
     * @param {保留位数} i 
     */
    static keepPoint(num,i) {
        if(this.hasPoint(num)){
            return Number(num).toFixed(i)
        }else{
            return Number(num);
        }
    }

    static getFullYear(){
       const nowDate = new Date();
       return nowDate.getFullYear()
    }
}